const Heading = (props) =>{
    const classes = "text-3xl font-semibold text-gray-900 " + props.className;
    return(
        <h2 className={classes}> {props.children}</h2>
    )
}
export default Heading